var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:eye-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.63683 13.384C2.69275 12.418 2.2207 11.9341 2.2207 10.5C2.2207 9.065 2.69275 8.58288 3.63683 7.616C5.52167 5.6875 8.68269 3.5 13.3276 3.5C17.9725 3.5 21.1335 5.6875 23.0183 7.616C23.9624 8.58375 24.4345 9.06587 24.4345 10.5C24.4345 11.935 23.9624 12.4171 23.0183 13.384C21.1335 15.3125 17.9725 17.5 13.3276 17.5C8.68269 17.5 5.52167 15.3125 3.63683 13.384Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6602 10.5C16.6602 11.1962 16.3092 11.8639 15.6843 12.3562C15.0594 12.8484 14.2119 13.125 13.3282 13.125C12.4444 13.125 11.5969 12.8484 10.972 12.3562C10.3471 11.8639 9.99609 11.1962 9.99609 10.5C9.99609 9.80381 10.3471 9.13613 10.972 8.64384C11.5969 8.15156 12.4444 7.875 13.3282 7.875C14.2119 7.875 15.0594 8.15156 15.6843 8.64384C16.3092 9.13613 16.6602 9.80381 16.6602 10.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9f35215fb7cd2de71cb2f21de5357a14.svg";
export { ForwardRef as ReactComponent };